// extracted by mini-css-extract-plugin
module.exports = {"Course":"Course_Course__3YbDd","CourseBox":"Course_CourseBox__18jKJ"};